<template>
  <div id="app">
    <the-title-section></the-title-section>
    <the-products-section></the-products-section>
    <the-contact-section></the-contact-section>
    <the-footer-section></the-footer-section>
  </div>
</template>

<script>
import {
  TheTitleSection,
  TheProductsSection,
  TheContactSection,
  TheFooterSection
} from "@/components";

export default {
  name: "App",
  components: {
    TheContactSection,
    TheTitleSection,
    TheProductsSection,
    TheFooterSection
  }
};
</script>

<style lang="scss">
/* Font import */
@import "@/fonts";

/* Global CSS */
@import "@/variables";

* {
  margin: 0;
  border: 0;
}

:root {
  font-size: 12px;
}

@media screen and (min-width: $screen-s) {
  :root {
    font-size: 16px;
  }
}

@media screen and (min-width: $screen-xl) {
  :root {
    font-size: 20px;
  }
}

#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  color: $black;
  text-align: center;
}

section {
  display: flex;

  flex-direction: column;
  align-items: center;

  padding: 6rem;
}

a {
  color: $blue;
  text-decoration: none;
  border-bottom: dotted $blue;
  font-weight: bold;
  white-space: nowrap;
}

a:hover {
  color: $blue;
  font-weight: bold;
  border-bottom: solid $blue;
  white-space: nowrap;
}

/* Atomic CSS */
.bg-white {
  background: $white;
}

.bg-yellow {
  background: $yellow;
}

.fs-l {
  font-size: 4rem;
}

.fs-m {
  font-size: 2rem;
  line-height: 1.4em;
}

.fs-s {
  font-size: 1.4rem;
  line-height: 2rem;
}

.fw-l {
  font-weight: lighter;
}
</style>
